import React from 'react';
import { observer } from 'mobx-react';

import RegistrationStore from 'onboarding/stores/RegistrationStore';
import { useAsyncFunction } from 'stores/hooks';
import AuthCard from 'ui-brand/components/AuthCard';
import Button from 'ui-brand/components/Button';
import { GlobeIcon } from 'ui-brand/components/icons';
import PasswordInput from 'ui-brand/components/PasswordInput';
import PhoneInput from 'ui-brand/components/PhoneInput';
import TextInput from 'ui-brand/components/TextInput';

function DetailsStep({ store }: { store: RegistrationStore }) {
  const [handleSubmit, isSubmitting] = useAsyncFunction(store.submitDetails);

  return (
    <AuthCard
      eyebrow={interpolate(gettext('Step %(step)s of 3'), { step: 2 }, true)}
      title={gettext('Tell us about your store')}
      subtitle={gettext('A few details about you and your store, and you can start.')}
    >
      <form
        className="mt-8 flex flex-col gap-5"
        onSubmit={(event) => {
          event.preventDefault();
          handleSubmit();
        }}
      >
        <fieldset disabled={isSubmitting} className="flex min-w-0 flex-col gap-5">
          <TextInput
            label={gettext('Store URL')}
            required
            placeholder="my-store.com"
            icon={<GlobeIcon />}
            autoComplete="url"
            value={store.data.shop_url}
            onChange={(value) => store.updateData({ shop_url: value })}
            error={store.errors.shop_url}
            name="shop-url"
          />
          <TextInput
            label={gettext('Store name')}
            required
            placeholder={gettext('My Store')}
            autoComplete="organization"
            value={store.data.account_name}
            onChange={(value) => store.updateData({ account_name: value })}
            error={store.errors.account_name}
            name="account-name"
          />
          <TextInput
            label={gettext('Your name')}
            required
            placeholder={gettext('John Doe')}
            autoComplete="name"
            value={store.data.full_name}
            onChange={(value) => store.updateData({ full_name: value })}
            error={store.errors.full_name}
            name="full-name"
          />
          <PasswordInput
            label={gettext('Password')}
            required
            placeholder={gettext('Choose a password')}
            autoComplete="new-password"
            value={store.data.password}
            onChange={(value) => store.updateData({ password: value })}
            error={store.errors.password}
            name="password"
          />
          <PhoneInput
            label={gettext('Phone')}
            optionalHint={gettext('(optional)')}
            country={store.phoneCountry}
            onCountryChange={store.setPhoneCountry}
            value={store.data.phone_number || ''}
            onChange={(value) => store.updateData({ phone_number: value })}
            error={store.errors.phone_number}
          />
        </fieldset>
        <Button type="submit" variant="primary" size="lg" fullWidth loading={isSubmitting}>
          {gettext('Continue')}
        </Button>
        <Button variant="secondary" size="sm" onClick={store.goBack} disabled={isSubmitting} className="self-center">
          {gettext('Back')}
        </Button>
      </form>
    </AuthCard>
  );
}

export default observer(DetailsStep);
